module.exports = __webpack_public_path__ + "static/media/no-data.d2eb9937.svg";